import React from 'react';
import cn from 'clsx';
import { CollectionPrice } from 'modules/collections';
import { formatToRub } from 'utils/format';
import { Typography } from '../typography';
import { CashbackPlate } from './cashback-plate';
import { DiscountPrice, DiscountPlateSize } from './discount-price';
import {
  priceView,
  priceViewDiscount,
  priceViewInLine,
  priceValue,
  priceValueWithDiscount,
  priceWrapper,
} from './price-view-styles';

type PriceViewProps = {
  className?: string;
  prefix?: string;
  size: DiscountPlateSize;
  showDiscountPlate?: boolean;
} & CollectionPrice;

export const PriceView: React.FC<PriceViewProps> = ({
  cashback, className, discount, prefix, price, prevPrice, size, showDiscountPlate = true
}) => (
  <div className={cn(className, { [priceViewInLine]: !showDiscountPlate })}>
    {(discount && prevPrice) && (
      <DiscountPrice
        className={cn({ [priceViewDiscount]: showDiscountPlate })}
        discount={discount}
        price={prevPrice}
        prefix={prefix}
        size={size}
        showDiscountPlate={showDiscountPlate}
      />
    )}

    <div className={priceView}>
      <Typography className={priceWrapper} variant="caption_accent" color={discount ? 'secondary-red-primary' : 'text-primary'}>
        {prefix && `${prefix}${' '}`}
        <span className={cn(priceValue, { [priceValueWithDiscount]: Boolean(discount) })}>
          {formatToRub(price)}{' '}
        </span>
        ₽
      </Typography>

      {cashback && <CashbackPlate cashback={cashback} size="m" />}
    </div>
  </div>
);
